import { z } from 'zod';
import { arrayFromQuery } from '../helpers/arrayFromQuery';
import { bigintItemFromQuery } from '../helpers/bigintItemFromQuery';
import { numberItemFromQuery } from '../helpers/numberItemFromQuery';
import { optionalDateFromQuery } from '../helpers/optionalDateFromQuery';
import { optionalNumberFromQuery } from '../helpers/optionalNumberFromQuery';

export const reviewOrdersSchema = z.object({
    telegramId: arrayFromQuery(bigintItemFromQuery),
    orderNumber: arrayFromQuery(numberItemFromQuery),

    dateAfter: optionalDateFromQuery,
    dateBefore: optionalDateFromQuery,

    minPrice: optionalNumberFromQuery,
    maxPrice: optionalNumberFromQuery,
});
export type ReviewOrdersSchema = z.infer<typeof reviewOrdersSchema>;
